import styled from "styled-components";

export const OperatorChatMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;

  p {
    margin: 0;
    text-align: center;
    max-width: 50%;
  }

  span {
    border-top: 1px solid;
    display: flex;
    flex-grow: 1;
  }
`
